// opervex-frontend/src/Opervex/HumanResources/Employees.js

class Employees {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Create
  async create(data) {
    return this.#_api.post("/HumanResources/Employees/", data);
  }

  // Update
  async update(id, data) {
    return this.#_api.put("/HumanResources/Employees/" + id, data);
  }

  // Find By Id
  async findId(id) {
    return this.#_api.get("/HumanResources/Employees/" + id);
  }

  // Find By Id
  async findIdFilter(id) {
    return this.#_api.get("/HumanResources/Employees/" + id + "/ByFilter");
  }

  // Find All
  async findAll() {
    return this.#_api.get("/HumanResources/Employees");
  }

  // Find All Seller
  async findAllSeller() {
    return this.#_api.get("/HumanResources/Employees?seller=true");
  }

  // Schema
  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "firstName",
        label: "Nome",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "lastName",
        label: "Sobrenome",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "cpf",
        label: "CPF",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "phone",
        label: "Telefone",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Employees;
